import Vue from 'vue'
import OssImg from './index'

Vue.component('OssImg', OssImg)



// WEBPACK FOOTER //
// ./src/components/oss-img/extra.js